export const overHalfOfTotalCommandsDownloaded = (
  downloadedCommands: boolean[],
  totalCommands: number
): boolean => {
  const numberOfDownloadedCommands = downloadedCommands.filter(
    (c: boolean) => c
  ).length;
  return numberOfDownloadedCommands >= Math.ceil(totalCommands / 2);
};
